/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ZipNotifyRegenerateZipfileResponse } from './ZipNotifyRegenerateZipfileResponse';

export type ZipNotifyRegenerateZipfileResponseApiRespoonse = {
    data?: ZipNotifyRegenerateZipfileResponse;
    status?: ZipNotifyRegenerateZipfileResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ZipNotifyRegenerateZipfileResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

